"use client";
import { useEffect, useState } from "react";

export function useCurrentHref() {
  const [href, setHref] = useState("");
  useEffect(() => setHref(window.location.href), []);
  return href;
}
